import { GET_DATA_HEADER_TABLEREPORT_PLANHANDLE } from "../actions/actionTypes";
import {
    GetDataHeaderTableReportHandleSuccessAction,
    RequestHeaderTableReportHandleFaileAction,
} from "../actions";

import { put, takeLatest } from "redux-saga/effects";
import { Api } from "./api";

function* GetHeaderTableReport(action) {
  try {
    const DataHeaderTableReport = yield Api.GetHeaderTableReportFromApi(action.id);
    yield put(GetDataHeaderTableReportHandleSuccessAction(DataHeaderTableReport));
  } catch (error) {
    yield put(RequestHeaderTableReportHandleFaileAction(error));
  }
}
export function* watchGetHeaderTableReport() {
  yield takeLatest(GET_DATA_HEADER_TABLEREPORT_PLANHANDLE, GetHeaderTableReport);
}
